const heroSlider = (container, options = 0) => {

    const $container = $(container);

    let slide_index = 2;
    let owl = $container.owlCarousel(options);
    const $animated_round = $('.js-animated-round');

    /*Replace loop with translating to first item*/
    owl.on('changed.owl.carousel', function(event) {
        slide_index = event.item.index;
        let length = $container.find('.owl-item').length;

        if(slide_index+1 >= length) {

            setTimeout(function () {
                owl.trigger('to.owl.carousel', 0)
            }, options.autoplayTimeout)
        }
    });

    owl.on('translated.owl.carousel', function(event) {
        $animated_round.removeClass('active');
    });

    function update_dot_position() {

        let position = $('.js-hero-slider').find(".owl-item").eq(slide_index).find('span').position();

        if(position) {
            let left = position.left;
            let top = position.top;

            $animated_round.css({top: top, left: left});
        }
    }

    $('.js-hero-slider .section-heading__click').on('click', function () {
        console.log(3232);
    });


};

export default heroSlider;
